<script>
import {required, requiredIf} from 'vuelidate/lib/validators'
import {mapState} from 'vuex';
import {validateValidDate, validateDateAfter, validateMinNumber, validateWithinYear} from "../../services/ValidatorService";

export default {
    props: {
        row: {
            type: Object,
            required: true
        },
        removable: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        ...mapState({
            chosenYear: state => state.allocation.allocations.years.current
        }),
        fromClasses () {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.from.$dirty && this.$v.row.from.$error,
                'manage-allocation-form-row__input--success': this.$v.row.from.$dirty && !this.$v.row.from.$error
            }
        },
        toClasses () {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.to.$dirty && this.$v.row.to.$error,
                'manage-allocation-form-row__input--success': this.$v.row.to.$dirty && !this.$v.row.to.$error
            }
        },
        typeClasses () {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.type.$dirty && this.$v.row.type.$error,
                'manage-allocation-form-row__input--success': this.$v.row.type.$dirty && !this.$v.row.type.$error
            }
        },
        unitClasses () {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.units.$dirty && this.$v.row.units.$error,
                'manage-allocation-form-row__input--success': this.$v.row.units.$dirty && !this.$v.row.units.$error
            }
        },
        releaseTypeClasses () {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.releaseType.$dirty && this.$v.row.releaseType.$error,
                'manage-allocation-form-row__input--success': this.$v.row.releaseType.$dirty && !this.$v.row.releaseType.$error
            }
        },
        releaseMethodClasses () {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.releaseMethod.$dirty && this.$v.row.releaseMethod.$error,
                'manage-allocation-form-row__input--success': this.$v.row.releaseMethod.$dirty && !this.$v.row.releaseMethod.$error
            }
        },
        releaseDateClasses () {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.releaseDate.$dirty && this.$v.row.releaseDate.$error,
                'manage-allocation-form-row__input--success': this.$v.row.releaseDate.$dirty && !this.$v.row.releaseDate.$error
            }
        },
        releaseDaysClasses () {
            return {
                'manage-allocation-form-row__input--error': this.$v.row.releaseDays.$dirty && this.$v.row.releaseDays.$error,
                'manage-allocation-form-row__input--success': this.$v.row.releaseDays.$dirty && !this.$v.row.releaseDays.$error
            }
        },
    },
    methods: {
        update (obj) {
            this.$v.$touch();
            this.$emit('update', { ...this.row, ...obj });
        },
        add () {
            this.$emit('add');
        },
        remove () {
            if (this.removable) {
                this.$emit('remove');
            }
        },
        duplicate() {
            this.$emit('duplicate', this.row)
        }
    },
    validations() {
        return {
            row: {
                from: {
                    required,
                    validateValidDate,
                    validateWithinYear: (date) => {
                        return validateWithinYear(date, this.chosenYear)
                    }
                },
                to: {
                    required,
                    validateDateAfter,
                    validateValidDate,
                    validateWithinYear: (date) => {
                        return validateWithinYear(date, this.chosenYear)
                    }
                },
                type: {
                    required
                },
                units: {
                    required: requiredIf((nestedRow) => {
                        return nestedRow.type === 'ALLOTMENT'
                    }),
                    validateMinNumber: (units, allocation) => {
                        if (allocation.type === 'ALLOTMENT') {
                            return validateMinNumber(units)
                        }
                        return true;
                    }
                },
                releaseType: {
                    required
                },
                releaseMethod: {
                    required
                },
                releaseDays: {
                    required: requiredIf((nestedRow) => {
                        return nestedRow.releaseMethod === 'days'
                    })
                },
                releaseDate: {
                    validateValidDate,
                    required: requiredIf((nestedRow) => {
                        return nestedRow.releaseMethod === 'date'
                    })
                }
            }
        }
    }
}
</script>
<template>
    <div class="manage-allocation-form-row">
        <div class="manage-allocation-form-row__fields">
            <div class="manage-allocation-form-row__field">
                <input v-mask="'##/##/####'" :value="row.from"
                       :placeholder="$t('manageAllocationFormRow.dateFormat')"
                       :class="fromClasses"
                       type="text"
                       class="manage-allocation-form-row__input"
                       @input="update({from: $event.target.value})">
            </div>
            <div class="manage-allocation-form-row__field">
                <input v-mask="'##/##/####'" :value="row.to"
                       :placeholder="$t('manageAllocationFormRow.dateFormat')"
                       :class="toClasses"
                       type="text"
                       class="manage-allocation-form-row__input"
                       @input="update({to: $event.target.value})">
            </div>
            <div class="manage-allocation-form-row__field">
                <select :value="row.type"
                        :class="typeClasses"
                        class="manage-allocation-form-row__dropdown"
                        @input="update({type: $event.target.value})">
                    <option value="ALLOTMENT">{{ $t('manageAllocationFormRow.dropDown.allotment') }}</option>
                    <option value="FREESALE">{{ $t('manageAllocationFormRow.dropDown.freeSale') }}</option>
                </select>
            </div>
            <div class="manage-allocation-form-row__field">
                <input v-number-only :value="row.units"
                       :disabled="row.type === 'FREESALE' || row.type === '' || !row.type"
                       :placeholder="row.type === 'ALLOTMENT' ? 'No. of units' : 'For allotment only'"
                       :class="unitClasses"
                       type="text"
                       class="manage-allocation-form-row__input"
                       @input="update({units: $event.target.value})">
            </div>
            <div class="manage-allocation-form-row__field">
                <select :value="row.releaseMethod"
                        :class="releaseMethodClasses"
                        class="manage-allocation-form-row__dropdown"
                        @input="update({releaseMethod: $event.target.value})">
                    <option value="days">{{ $t('manageAllocationFormRow.dropDown.days') }}</option>
                    <option value="date">{{ $t('manageAllocationFormRow.dropDown.date') }}</option>
                </select>
            </div>
            <div class="manage-allocation-form-row__field">
                <input v-mask="'##/##/####'"
                       v-if="row.releaseMethod === 'date'" :placeholder="$t('manageAllocationFormRow.dateFormat')"
                       :value="row.releaseDate"
                       :class="releaseDateClasses"
                       type="text"
                       class="manage-allocation-form-row__input"
                       @input="update({releaseDate: $event.target.value, releaseDays: undefined})">

                <input v-number-only
                       v-if="row.releaseMethod === 'days'" :placeholder="$t('manageAllocationFormRow.days')"
                       :value="row.releaseDays"
                       :class="releaseDaysClasses"
                       type="text"
                       class="manage-allocation-form-row__input"
                       @input="update({releaseDays: $event.target.value, releaseDate: undefined})">
            </div>
            <div class="manage-allocation-form-row__field">
                <select :value="row.releaseType"
                        :class="releaseTypeClasses"
                        class="manage-allocation-form-row__dropdown"
                        @input="update({releaseType: $event.target.value})">
                    <option :value="undefined">{{ $t('manageAllocationFormRow.dropDown.selectType') }}</option>
                    <option value="REQUEST">{{ $t('manageAllocationFormRow.dropDown.request') }}</option>
                    <option value="FREESALE">{{ $t('manageAllocationFormRow.dropDown.freeSale') }}</option>
                    <option value="BLOCKED">{{ $t('manageAllocationFormRow.dropDown.blocked') }}</option>
                </select>
            </div>
        </div>
        <div class="manage-allocation-form-row__controls">
            <div class="manage-allocation-form-row__button"
                 @click="add">
                <i class="fa fa-fw fa-plus"/>
            </div>
            <div class="manage-allocation-form-row__button"
                 @click="duplicate">
                <i class="fa fa-fw fa-clone"/>
            </div>
            <div :class="{'manage-allocation-form-row__button--disabled': !removable}"
                 class="manage-allocation-form-row__button"
                 @click="remove">
                <i class="fa fa-fw fa-minus"/>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ManageAllocationFormRow/ManageAllocationFromRow.vue